import { combineReducers } from 'redux';
import util from '../util';
import {
  ANALYTICS_OVERVIEW,
  ANALYTICS_ONLINE,
  ANALYTICS_STORE,
  ANALYTICS_ONLINE_DEALS,
  ANALYTICS_STORE_DEALS,
  ANALYTICS_FEATURE_METRICS,
} from './actionTypes';

export default combineReducers({
  overview: util.requestReducer(ANALYTICS_OVERVIEW),
  onlineAnalytics: util.requestReducer(ANALYTICS_ONLINE),
  storeAnalytics: util.requestReducer(ANALYTICS_STORE),
  onlineDeals: util.requestReducer(ANALYTICS_ONLINE_DEALS),
  storeDeals: util.requestReducer(ANALYTICS_STORE_DEALS),
  featureMetrics: util.requestReducer(ANALYTICS_FEATURE_METRICS),
});
